import React from 'react'
import Link from 'gatsby-link'

const Work = ({
  url,
  className = '',
  phone,
  laptop,
  color,
  screen,
  raise = false
}) =>

  <div className={`project ${className}`} style={{backgroundColor: `${color}`}}>
    {url && <Link to={url} />}

    {phone &&
      <div className={`image phone ${raise && 'raise'}`}>
        <img className='device' src='/static/iphone2.png' alt='' />
        <img className='screen' src={screen} alt='' />
      </div>
    }

    {laptop &&
      <div className={`image laptop ${raise && 'raise'}`}>
        <img className='device' src='/static/macbook.png' alt='' />
        <img className='screen' src={screen} alt='' />
      </div>
    }

  </div>

export default Work



// WEBPACK FOOTER //
// ./src/components/work.js